import React from 'react'

import NavBar from "./NavBar";
import Footer from "./Footer";

const AbtInvestorCharter = () => { return (
        <div>
      <NavBar />
      <main id="main">
      <section id="invertorCharter" class="innerPage">
            <div class="container">
                <div class="section-title">
                    <h2>Customer Service Timelines</h2>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="table-responsive">
                            <table class="table table-striped table-bordered">
                                <tr>
                                    <td><i class="ri-survey-line"></i></td>
                                    <td>Investor Registration</td>
                                    <td>10 am to 6 pm on Working Days</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-video-chat-line"></i></td>
                                    <td>Investor VKYC Timings</td>
                                    <td>10 am to 6 pm on Working Days</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-chat-check-line"></i></td>
                                    <td>Investor Approval Process</td>
                                    <td>Within 3-4 working days of Investor Registration completion, if all KYC proof and documents are proper and valid.</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-time-line"></i></td>
                                    <td>Bidding Timing</td>
                                    <td>As per time specified for each Auction Security</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-timer-flash-line"></i></td>
                                    <td>Bid Funding Timings</td>
                                    <td>As per time specified for Net Banking/UPI for respective Auction Security</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-refund-line"></i></td>
                                    <td>Funds Refund on Allotment</td>
                                    <td>Within two working day post Auction Allotment by RBI</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-bank-line"></i></td>
                                    <td>Funds Refund on Bid Cancellation</td>
                                    <td>Within two working day post Cancellation</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-government-line"></i></td>
                                    <td>Securities Allotment</td>
                                    <td>On the date of Auction Allotment</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-shield-check-line"></i></td>
                                    <td>Securities Settlement in RDG Account</td>
                                    <td>Within one working day of Securities Credit from RBI</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-service-line"></i></td>
                                    <td>NDS OM Access Registration</td>
                                    <td>10 am to 6 pm on Working Days</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-check-double-line"></i></td>
                                    <td>NDS OM Access Approval</td>
                                    <td>Within One working day of Investor request for Access to NDS OM</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-mail-check-line"></i></td>
                                    <td>Holding Statement in Email</td>
                                    <td>Monthly</td>
                                </tr>
                                <tr>
                                    <td><i class="ri-questionnaire-line"></i></td>
                                    <td>Support Desk</td>
                                    <td>10 am to 6 pm on Working Days</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </section>
       </main>
      <Footer />
    </div>) };export default AbtInvestorCharter